export default __webpack_public_path__ + "static/media/Info_icon.5cbb109c.svg";